import React, { useEffect, useState } from "react";
import { Plus } from "shared/assets/icons";

import { ButtonContainer, Button, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

import {
  IEquipmentSubcategoryItem,
  IStageEquipmentCategory,
} from "Venues/types";

import { copy } from "shared/assets";
import { EditEquipment } from "./EditEquipment";
import { EditSubcategory } from "./EditSubcategory";
const {
  editEquipment: { addEquipment, addMoreInfo },
} = copy;

interface EditEquipmentBlockSubcategoryProps {
  category: IEquipmentSubcategoryItem;
  handleCategorySubmit: (data: IStageEquipmentCategory) => void;
}

enum AddForm {
  Equipment,
  MoreInfo,
}

export const EditEquipmentBlockSubcategory: React.FC<EditEquipmentBlockSubcategoryProps> =
  ({ category, handleCategorySubmit }) => {
    const [openForm, setOpenForm] = useState<AddForm | null>(null);
    const toggleOpenForm = (form: AddForm) => {
      if (openForm === form) {
        setOpenForm(null);
        return;
      }

      setOpenForm(form);
    };

    // Open More info form on first render if there is text
    useEffect(() => {
      if (category.text) {
        setOpenForm(AddForm.MoreInfo);
      }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <Spacer size="m">
        <Title asComponent="h3" size="s" title={category.label} />
        <ButtonContainer>
          <Button
            data-testid={`add_equipment_${category.category}`}
            onClick={() => toggleOpenForm(AddForm.Equipment)}
            fakeDisabled={openForm === AddForm.Equipment}
          >
            <Icon as={Plus} />
            <span>{addEquipment.cta}</span>
          </Button>
          <Button
            data-testid={`add_info_${category.category}`}
            theme={ITheme.secondary}
            onClick={() => toggleOpenForm(AddForm.MoreInfo)}
            fakeDisabled={openForm === AddForm.MoreInfo}
          >
            <Icon as={Plus} />
            <span>{addMoreInfo.cta}</span>
          </Button>
        </ButtonContainer>
        {openForm === AddForm.MoreInfo && (
          <EditSubcategory
            category={category}
            handleCategorySubmit={handleCategorySubmit}
            closeForm={() => setOpenForm(null)}
          />
        )}
        {openForm === AddForm.Equipment && (
          <EditEquipment
            category={category}
            closeForm={() => setOpenForm(null)}
          />
        )}
      </Spacer>
    );
  };
